<p class="text--bold caption">
  Alternativ können Sie den {{ organisation().customFields['amountLabel'] || 'Beitrag' }} auch auf dieses Konto
  überweisen.
</p>
<div class="payment-informations">
  <p id="paymentReceiver">Empfänger: {{ manualPaymentConfiguration().paymentReceiver }}</p>
  <p id="iban">IBAN: {{ formatIban(manualPaymentConfiguration().iban) }}</p>
  <p id="bic">BIC: {{ manualPaymentConfiguration().bic }}</p>
  <p id="bank">Bank: {{ manualPaymentConfiguration().bank }}</p>
  <p id="reasonForPayment">Verwendungszweck: {{ reasonForPayment() }}</p>
</div>
